export default {
	project_name: 'Plataforma de Capacitações Grupo Boticário',
}
